import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Modal } from "flowbite-react";
import { CustomButton } from "../../../atoms/CustomButton";
import { useUserResendEmailVerification } from "../../../../hooks/users";
import { Timer } from "../../../../utils/Timer";

interface EmailVerificationModalProps {
  show: boolean;
  email: string;
  password: string;
  userId: string;
  entityIdentification: string;
  onVerifyClick: () => void;
  isVerifying: boolean;
  onClose?: () => void;
}

export const EmailVerificationModal: React.FC<EmailVerificationModalProps> = ({
  show,
  email,
  password,
  userId,
  entityIdentification,
  onVerifyClick,
  isVerifying,
  onClose,
}) => {
  const { t } = useTranslation("clientView");
  const [showTimer, setShowTimer] = useState(false);

  const { mutate: resendEmail, isLoading: isResending } =
    useUserResendEmailVerification();

  const handleResendEmail = () => {
    resendEmail(
      {
        entity_identification: entityIdentification,
        userId: userId,
      },
      {
        onSuccess: () => {
          setShowTimer(true);
        },
        onError: () => {
          setShowTimer(false);
        },
      }
    );
  };

  return (
    <Modal show={show} size="lg" dismissible onClose={onClose}>
      <Modal.Body className="flex-col bg-gray-800 rounded-md justify-center items-center gap-5 inline-flex">
        <img
          title="Super User Manager"
          loading="lazy"
          src="https://cdn.1cdn.app/application/UMD/umd_verify_your_email.svg"
          alt="Super User Manager"
          className=""
          width={217}
        />
        <div className="flex-col justify-center items-center gap-2 inline-flex">
          <h2 className="text-center text-gray-200 text-2xl font-bold font-figtree leading-loose">
            {t("register.confirmEmailModal.text_1")}
          </h2>
          <p className="text-center text-gray-200 text-sm font-normal font-figtree leading-tight">
            {t("register.confirmEmailModal.text_3")} <b>{email}</b>{" "}
            {t("register.confirmEmailModal.text_4")}
          </p>
        </div>

        <div className="flex justify-center items-center gap-3">
          <CustomButton
            variant="gray"
            onClick={handleResendEmail}
            disabled={showTimer}
            isLoading={isResending}
            title={t("register.confirmEmailModal.btn_2") as string}
            comp={
              showTimer && (
                <span className="text-muted ms-2">
                  <Timer setShowTimer={setShowTimer} ttl={120} />{" "}
                  {t("register.confirmEmailModal.text_5")}
                </span>
              )
            }
          />
          <CustomButton
            variant="primary"
            onClick={onVerifyClick}
            disabled={isVerifying}
            isLoading={isVerifying}
            title={t("register.confirmEmailModal.btn_1") as string}
          />
        </div>
      </Modal.Body>
    </Modal>
  );
};
